import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const LockIcon: React.FunctionComponent<IconProps> = ({
  width = 16,
  height = 22,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={16} viewBoxHeight={22} {...rest}>
    <path d="M14 7.5H13V5.5C13 2.74 10.76 0.5 8 0.5C5.24 0.5 3 2.74 3 5.5V7.5H2C0.9 7.5 0 8.4 0 9.5V19.5C0 20.6 0.9 21.5 2 21.5H14C15.1 21.5 16 20.6 16 19.5V9.5C16 8.4 15.1 7.5 14 7.5ZM8 16.5C6.9 16.5 6 15.6 6 14.5C6 13.4 6.9 12.5 8 12.5C9.1 12.5 10 13.4 10 14.5C10 15.6 9.1 16.5 8 16.5ZM11.1 7.5H4.9V5.5C4.9 3.79 6.29 2.4 8 2.4C9.71 2.4 11.1 3.79 11.1 5.5V7.5Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon/lock.icon.tsx